@if (!isLoading) {
  <div>
    <label class="form-label">
      When Onsite work is approved:
    </label>

    <div [formValidation]="implementationOwnerControl">
    @for (option of implementationOwnerOptions; track option) {
    <div class="mb-2">
      <div class="form-check d-flex align-items-center gap-2" [class.py-2]="option.value !== implementationOwners_Custom" [class.py-1]="option.value === implementationOwners_Custom">
        <label class="form-check-label d-flex align-items-center gap-2 mb-0">
          <input class="form-check-input mt-0" type="radio" [formControl]="implementationOwnerControl" name="implementationOwner" [value]="option.value" [attr.disabled]="option.value === implementationOwners_Partner && !partnerImplementationContactEmail ? true : null" />
          <span class="d-flex align-items-center gap-2 flex-wrap">
            {{ option.label }} <app-components-helptext [key]="option.helpKey"></app-components-helptext>
            @if (option.value === implementationOwners_Partner) {
              @if (partnerImplementationContactEmail) {
                <span class="text-muted">({{ partnerImplementationContactEmail }})</span>
              } @else {
                <span class="text-muted fst-italic">(no Partner Implementation Email set)</span>
              }
            }
            @if (option.value === implementationOwners_Custom) {
              <span class="d-inline-block">
                <input type="text" class="form-control form-control-sm w-auto py-0" style="min-width: 325px;" placeholder="Email" [formControl]="customEmailControl" [formValidation]="customEmailControl" [readOnly]="implementationOwnerControl.value !== implementationOwners_Custom" />
              </span>
            }
          </span>
        </label>
      </div>
    </div>
    }
    </div>
  </div>
}